// UI navigation only. APIs independently enforce facility/object/action scope.
export const LABORATORY_ROLES = Object.freeze([
  'lab_scientist', 'senior_lab_scientist', 'lab_admin', 'phlebotomist',
  'microbiologist', 'histotechnologist', 'cytotechnologist', 'pathologist',
  'consultant_pathologist', 'quality_manager', 'inventory_manager',
]);

// Compliance has its own read-only portal; LIS API audit access does not grant
// the general laboratory workspace. Cross-functional roles keep their own home.
export const LABORATORY_PORTAL_ROLES = Object.freeze([
  ...LABORATORY_ROLES, 'admin', 'facility_admin', 'clinician', 'super_clinician',
]);
export const canAccessLaboratory = role => LABORATORY_PORTAL_ROLES.includes(role);

export function getRoleRedirectPath(userOrRole) {
  const role = typeof userOrRole === 'object' ? userOrRole?.role : userOrRole;
  if (!role) return '/login';
  if (LABORATORY_ROLES.includes(role)) return '/laboratory';
  if (role === 'referring_physician') return '/referring-physician';
  if (['radiographer', 'technologist'].includes(role)) return '/technologist';
  if (['clinician', 'super_clinician', 'sonographer', 'nurse', 'medical_records_officer'].includes(role)) return '/clinician';
  if (role === 'radiologist') return userOrRole?.radiologistType !== 'facility' ? '/radiologist/reader-portal' : '/radiologist';
  if (role === 'facility_admin') return '/facility-admin';
  if (role === 'it_admin') return '/it-admin';
  if (['compliance_officer', 'compliance_internal'].includes(role)) return '/compliance';
  if (['admin', 'tech_support', 'product_lead', 'customer_success'].includes(role)) return '/admin';
  return '/portal';
}
